import { Injectable } from '@angular/core';

import { FirestorePathsService } from './firestorePaths.service';
import { FirestoreService } from '../lib/firestore.service';
import type { TDealership } from '@shared/models';

@Injectable({
    'providedIn': 'root'
})
export class DealershipService {
    private documentName = 'dealershipProfile';

    constructor(private firestoreService: FirestoreService, private firestorePathsService: FirestorePathsService) {
    }

    public getNullable(): TDealership {
        const dealership: TDealership = {
            'address': {
                'city': '',
                'coordinate': { 'latitude': 0, 'longitude': 0 },
                'countryName': '',
                'isoCountryCode': '',
                // 'isoRegionCode': '',
                // 'formattedAddress': '',
                'fullAddress': '',
                'regionName': '',
                'regionCode': '',
                'streetAddress': '',
                'zipcode': '',
                'countryAbbr': ''
            },
            'dealershipName': '',
            'phoneNumber': '',
            'uid': ''
        };
        return dealership;
    }

    public async get(): Promise<TDealership | null> {
        const path = this.firestorePathsService.getDealershipPath();
        const dealership = await this.firestoreService.get(path);
        if (dealership === null) {
            return null;
        }
        return dealership as TDealership;
    }

    public async getAccountNumber(accountNumber: string): Promise<TDealership | null> {
        this.firestorePathsService.setAccountNumber(accountNumber);
        return this.get();
    }

    public async getDealershipByAccountNumber(accountNumber: string): Promise<TDealership> {
        const path = this.firestorePathsService.getDealershipPathByAccountNumber(accountNumber);
        return this.firestoreService.get(path) as Promise<TDealership>;
    }

    public async set(dealership: TDealership): Promise<TDealership> {
        dealership.uid = this.documentName;
        const path = this.firestorePathsService.getProfilesPath();
        return this.firestoreService.set(path, dealership) as Promise<TDealership>;
    }

    public async update(dealership: TDealership): Promise<TDealership> {
        const path = this.firestorePathsService.getProfilesPath();
        return this.firestoreService.update(path, dealership) as Promise<TDealership>;
    }
}
